import type { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import type { UserSettingsValue } from "../../../services/api/instances/useSettingsApi/types";
import {
  authAction,
  getAllSettingsObjectsAction,
  updateUserSettingsAction,
} from "./actions";
import type { AuthState } from "./types";

export function getAllSettingsObjectReducerBuilder(
  builder: ActionReducerMapBuilder<AuthState>,
) {
  builder.addCase(getAllSettingsObjectsAction.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.settingsObjects = action.payload.settingsObjects;
    if (action.payload.settingsObject) {
      const settings = action.payload.settingsObject?.value;
      state.settingsObject = action.payload.settingsObject;
      state.userSettings = settings as UserSettingsValue;
    }
  });
}

export function authReducerBuilder(
  builder: ActionReducerMapBuilder<AuthState>,
) {
  builder.addCase(authAction.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.userSettings = action.payload.userSettingsObject?.value;
    state.settingsObject = action.payload.userSettingsObject;
    state.userInfo = action.payload.userInfo;
    state.isAuthenticated = true;
    state.isLoading = false;
  });
  builder.addCase(authAction.rejected, (state) => {
    state.isLoading = false;
  });
}

export function updateUserSettingsReducerBuilder(
  builder: ActionReducerMapBuilder<AuthState>,
) {
  builder.addCase(updateUserSettingsAction.fulfilled, (state, action) => {
    state.settingsObject = action.payload;
    state.userSettings = action.payload?.value;
  });
}
